import { AppState } from 'reducers'

export const featureFlags = (state: AppState) => state.featureFlags
